import { configureStore } from "@reduxjs/toolkit";
import modalSlice from "./features/globalModalSlice";
import messageSlice from "./features/messageSlice";
import searchSlice from "./features/searchSlice";
import auth from "./features/auth";
import messageActionSlice from "./features/messageActionSlice";

export const store = configureStore({
  reducer: {
    globalModal: modalSlice,
    messages: messageSlice,
    users: searchSlice,
    auth: auth,
    messageActionModal: messageActionSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
